import { DateTime, Settings } from 'luxon';
import { formattedCurrency, shiftHasDropPenalty } from '../../../utils';
import { PayCategory, PayModifierCategory } from '@amzn/atoz-shiftapp-types';
import { ShiftFlowModalContentTypes } from '../ShiftFlowModalTypes';
import { formatDuration } from '@amzn/atoz-shiftapp-utilities';
import { useTranslation } from 'react-i18next';
export var useDropMultipleShiftModalData = function (_a) {
    var selectedDropOpportunity = _a.selectedDropOpportunity, dropOpportunities = _a.dropOpportunities, setModalContent = _a.setModalContent;
    var showPremiumPayBanner = dropOpportunities.some(function (dropOpportunity) {
        return isPremiumPayBreakDownAvailable(dropOpportunity);
    });
    var monthAndDateStr = getMonthAndDateStrsFromDropOpportunities(dropOpportunities);
    var onClickContinue = function () {
        if (selectedDropOpportunity !== null) {
            setModalContent(ShiftFlowModalContentTypes.confirmDrop);
        }
    };
    var isContinueButtonEnabled = dropOpportunities.some(function (dropOpportunitity) {
        return selectedDropOpportunity != null &&
            dropOpportunitity.id === selectedDropOpportunity.id;
    });
    return {
        onClickContinue: onClickContinue,
        monthAndDateStr: monthAndDateStr,
        showPremiumPayBanner: showPremiumPayBanner,
        isContinueButtonEnabled: isContinueButtonEnabled
    };
};
export function isPremiumPayBreakDownAvailable(dropOpportunity) {
    if (dropOpportunity.payBreakdown &&
        dropOpportunity.payBreakdown.premiums &&
        dropOpportunity.payBreakdown.premiums.length !== 0) {
        return true;
    }
    return false;
}
export function getMonthAndDateStrsFromDropOpportunities(dropOpportunities) {
    var monthAndDateSet = new Set();
    var monthAndDateStr = '';
    dropOpportunities.map(function (dropOpportunity) {
        var startTime = DateTime.fromISO(dropOpportunity.shift.timeRange.start);
        var monthStr = startTime
            .setLocale(Settings.defaultLocale)
            .toLocaleString({ month: 'short' });
        var weekDayStr = startTime
            .setLocale(Settings.defaultLocale)
            .toLocaleString({ weekday: 'short' });
        monthAndDateSet.add("".concat(weekDayStr, " ").concat(monthStr, " ").concat(startTime.day));
    });
    Array.from(monthAndDateSet).map(function (str, index) {
        monthAndDateStr += str;
        if (index < monthAndDateSet.size - 1) {
            monthAndDateStr += ' - ';
        }
    });
    return monthAndDateStr;
}
export function getPremiumPayCurrencyStrs(premiums) {
    if (!premiums || premiums.length === 0) {
        return null;
    }
    var premiumPayCurrencyStrs = [];
    premiums.forEach(function (premium) {
        var currencyStr = formattedCurrency(premium.hourlyCompensation);
        if (currencyStr) {
            premiumPayCurrencyStrs.push(currencyStr);
        }
    });
    return premiumPayCurrencyStrs;
}
export function getPremiumPayCategory(premiums) {
    switch (premiums === null || premiums === void 0 ? void 0 : premiums.category) {
        case PayCategory.HighDemandPremium:
            return 'HDP';
        case PayCategory.NightAndWeekendPremium:
            return 'NWP';
        case PayCategory.PeakHiringPremium:
            return 'Peak';
    }
    return null;
}
export function getPayModifierCategory(payModifier) {
    switch (payModifier === null || payModifier === void 0 ? void 0 : payModifier.category) {
        case PayModifierCategory.HighDemandPremium:
            return 'HDP';
        case PayModifierCategory.NightAndWeekendPremium:
            return 'NWP';
        case PayModifierCategory.PeakHiringPremium:
            return 'Peak';
    }
    return null;
}
export function getPayModifierCategoryStr(PayModifier) {
    var payModifierCategory = getPayModifierCategory(PayModifier);
    return payModifierCategory ? "(".concat(payModifierCategory, ")") : null;
}
export function getPremiumPayCategoryStr(premiums) {
    var premiumCategory = getPremiumPayCategory(premiums);
    return premiumCategory ? "(".concat(premiumCategory, ")") : null;
}
export var useRadioCardMessageStr = function (_a) {
    var _b;
    var dropOpportunity = _a.dropOpportunity, scheduleShift = _a.scheduleShift, premiums = _a.premiums;
    var t = useTranslation().t;
    var hasDropPenalty = shiftHasDropPenalty(scheduleShift, dropOpportunity);
    var hasIncentivePay = !!dropOpportunity.incentivePay;
    var dropPenaltyMessage = t('shift_management_features_MultipleDropShiftModal_radio_message_drop_penalty');
    var mergedShiftPremiumPayTitle = t('shift_management_features_MultipleDropShiftModal_premium_pay_applied');
    var dropWithOutPenaltyMessage = dropOpportunity && dropOpportunity.penaltyStartTime
        ? t('shift_management_features_MultipleDropShiftModal_radio_message_drop_without_penalty') +
            ' ' +
            formatDuration(DateTime.fromISO(dropOpportunity.penaltyStartTime).diff(DateTime.utc(), ['hours', 'minutes', 'seconds']))
        : '';
    var premiumPayMessage = premiums
        ? "".concat(mergedShiftPremiumPayTitle, " ").concat(premiums
            .map(function (premium) {
            return "".concat(formattedCurrency(premium.hourlyCompensation), " ").concat(getPremiumPayCategoryStr(premium));
        })
            .join(', '))
        : hasIncentivePay
            ? "".concat(mergedShiftPremiumPayTitle, " ").concat((_b = dropOpportunity.incentivePay) === null || _b === void 0 ? void 0 : _b.payModifiers.map(function (payModifier) {
                return "".concat(formattedCurrency(payModifier.hourlyAdditionalCompensation), " ").concat(getPayModifierCategoryStr(payModifier));
            }).join(', '))
            : '';
    var penaltyMessage = hasDropPenalty
        ? dropPenaltyMessage
        : dropWithOutPenaltyMessage;
    return "".concat(penaltyMessage).concat(penaltyMessage && premiumPayMessage ? '\n' : '').concat(premiumPayMessage).trim();
};
